<template>
   <div>
    <loader :is-visible="isLoading"></loader>
    <div class="container">
        <div class="container-post">
            <div class="form-modal">
                <div> 
                    <div class="section-modal">
                        <button  class="close btn--close" @click="back()"></button>
                        <div class="wrapper">
                            <p>Gallery Type</p>
                            <select class="select-css mg-top1" v-model="type">
                                <option value="" disabled selected>Select type:</option>
                                <option value="picture" >Picture</option>
                                <option value="infographic">Infographic</option>
                                <option value="video">Video</option>
                            </select>
                            <div class="grid-modal mg-top" v-if="type">
                                <div class="section-modal">
                                    <template v-if="type === 'picture' || type === 'infographic'">
                                    <!-- <template v-if="type === 'picture'"> -->
                                        <p>Upload Image</p>
                                        <input id="assetUpload" type="file" accept="image/*" @change="onAddFile($event)" hidden> 
                                        <div class="mg-top1">
                                            <img class="imgUpload" v-if="assetImgUrl" :src="assetImgUrl" alt="">
                                            <button class="btn-upload mg-top1 mg-right" @click="chooseFiles()">Choose</button>
                                        </div>
                                    </template>
                                    <template v-if="type === 'video'">
                                        <p v-if="urlEmbed">View Video</p>
                                        <div class="txt-center">
                                            <iframe :src="urlEmbed" v-if="urlEmbed" class="mg-top1" frameborder="0"></iframe>
                                        </div>
                                        <div class="input-data mg-top">
                                            <input type="text" required v-model="embed" @change="getIdUrl">
                                            <div class="underline"></div>
                                            <label>Embed Video</label>
                                        </div>
                                    </template>
                                    <div class="text-area mg-top">
                                        <textarea v-model="description" :maxlength="max" required></textarea>
                                        <div class="underline"></div>
                                        <label>Description</label>
                                    </div>
                                </div>

                                <div class="section-modal">
                                    <div class="date--picker">
                                        <p class="mg-btm-5">Event Date</p>
                                        <!-- <datepicker placeholder="Select Date" 
                                            v-model="event_date" 
                                            >
                                        </datepicker> -->
                                        <date-picker class="mg-top1" v-model="event_date" :disabled-date="disabledDates" value-type="date" type="datetime"></date-picker>
                                    </div>
                                    <div class="input-data mg-top">
                                        <input type="number" min="0" required v-model="order_id">
                                        <div class="underline"></div>
                                        <label>Order Id</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>        
                <div class="btn-heading">
                    <p class="mg-top" v-if="errors.length">
                        <b>Please correct the following error(s):</b>
                        <ul>
                            <li class="red" v-for="(error,index) in errors" :key="index">{{ error }}</li>
                        </ul>
                    </p>

                    <button class="btn-add mg-top1" v-if="type" @click="validation(id != 0 ? 'update' : 'add')">
                        <!-- Add Post -->
                        {{id != 0? 'Update' : 'Add'}} Post
                    </button>
                </div>     
            </div>
        </div>
    </div>
   </div>
</template>

<script>
import Loader from './../components/Loader.vue';
import alert from './../commons/alert.helper';
import axios from 'axios';
// import Datepicker from 'vuejs-datepicker';
import DatePicker from 'vue2-datepicker';
import moment from 'moment';

import 'vue2-datepicker/index.css';

import auth from '@/service/auth.js'

export default {
    name: "GaleriPerindoForm",
    data() {
        return {
            isLoading: false,
            id: '',
            order_id: '',
            assetImage: null,
            assetImgUrl : null,
            description: '',
            errors: [],
            max: 150,
            type: '',
            picture: null,
            infographic: null,
            video: null,
            embed: '',
            urlEmbed: '',
            event_date: '',
        }
    },
    methods: {
        disabledDates(date) {
            return date > new Date()
        },
        getIdUrl (e) {
            console.log('event', e)
            const url = e.target.value
            let id = ''

            if (url.includes('v=')) {
                id = url.split('v=')[1]
                console.log('url', url)
                this.urlEmbed = `https://www.youtube.com/embed/${id}`
            } else if (url.includes('youtu.be/')) {
                id = url.split('youtu.be/')[1]
                this.urlEmbed = `https://www.youtube.com/embed/${id}`
            } else {
                this.urlEmbed = url
            }

        },
        validation(type) {
            this.errors = []

            if (!this.type) this.errors.push('* Type required')
            if (!this.order_id) this.errors.push('* OrderId required')
            if (!this.event_date) this.errors.push('* Event Date required')
            // if (!this.assetImage) this.errors.push('* Image required')
            if (!this.description) this.errors.push('* Description required')
            

            if (this.errors.length > 0) {
                return
            } else if (type === 'add') {
                this.addPerindo()
            } else if (type === 'update') {
                this.updatePerindo()
            }
        },
        async addPerindo() {
            const res = await auth.checkAuth(this.$route.fullPath)
            if (res == false) {
                localStorage.clear()
                alert.failed('Unauthorized Token', () => this.$router.push('/login'))
            } else {
                try { 
                    this.isLoading = true
                    const formData = new FormData()

                    let date = moment(this.event_date).format()
                    
                    formData.append('type', this.type)
                    formData.append('order_id', this.order_id)
                    formData.append('embed', this.embed)
                    formData.append('asset', this.assetImage)
                    formData.append('description', this.description)
                    formData.append('event_date', date)
    
                    const response = await axios.post('/content/gallery', formData)
                    this.isLoading = false
    
                    console.log(response)
                    if(response.status == 200) {
                        alert.success('Add data success', () => this.$router.go(-1))
                    }
    
                } catch (error) {
                    console.log(error)
                }
            }
        },
        async getDataPerindo() { 
                let dataId = localStorage.getItem('dataPerindoById')
                
                let data = JSON.parse(dataId)
                
                this.type = data.type
                this.urlEmbed = `https://www.youtube.com/embed/${data.embed.String}`
                this.embed = `https://www.youtube.com/embed/${data.embed.String}` 
                this.order_id = data.order_id
                this.assetImage = data.asset
                this.assetImgUrl = data.asset.String
                this.description = data.description
                // this.event_date = data.event_date
                this.event_date = new Date (data.event_date)
        },
        async updatePerindo() {
            const res = await auth.checkAuth(this.$route.fullPath)
            if (res == false) {
                localStorage.clear()
                alert.failed('Unauthorized Token', () => this.$router.push('/login'))
            } else {
                try {
                    this.isLoading = true
                    const formData = new FormData()

                    let date = moment(this.event_date).format()
                    
                    formData.append('id', this.id)
                    formData.append('type', this.type)
                    formData.append('order_id', this.order_id)
                    formData.append('embed', this.embed)
                    formData.append('asset', this.assetImage)
                    formData.append('description', this.description)
                    formData.append('event_date', date)
    
                    const response = await axios.patch(`/content/gallery/${this.id}`, formData)
                    this.isLoading = false
    
                    console.log(response)
                    if(response.status == 200) {
                        alert.success('Update data success', () => this.$router.go(-1))
                    }
    
                } catch (error) {
                    console.log(error)
                    this.isLoading = false
                    alert.failed('Update data failed')
                }
            }
        },
        onAddFile (e) {
            console.log(e)
            this.assetImage = e.target.files[0]
            this.assetImgUrl = URL.createObjectURL(this.assetImage)
            console.log('asset', this.assetImage)
            console.log('assetUrl', this.assetImgUrl)
        },
        chooseFiles() {
            document.getElementById("assetUpload").click()
        },
        back() {
            this.$router.go(-1)
        }
    },
    components: {
        // Datepicker,
        DatePicker,
        Loader
    },
    created() {
        this.id = this.$route.params.id
        if(this.id != 0) {
            this.getDataPerindo();
        }
    },
    
}
</script>